import api from 'src/utils/axios'; // sesuaikan path axios instance kamu

export const getNotRepliedComplaintCount = async (): Promise<number> => {
  const response = await api.get('/admin/complaint/not-replied-count');
  return response?.data?.data?.count ?? 0;
};
